import { getKhoroojInfo, getKhoroojHistory, getLastKhorooj } from '@/api/khorooj'
export default {
    state: {
        khoroojInfo: {},
        history: [],
        last: {},

    },

    mutations: {

        SET_KHOROOJ_INFO: (state, data) => {
            state.khoroojInfo = data
        },
        SET_KHOROOJ_HISTORY: (state, data) => {
            state.history = data
        },
        SET_LAST_KHOROOJ: (state, data) => {
            state.last = data
        }

    },

    actions: {
        getKhoroojInfo({ commit }) {

            return new Promise((resolve, reject) => {
                getKhoroojInfo().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_KHOROOJ_INFO', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getKhoroojHistory({ commit }) {
            commit('SET_TABLE_TEXT', true)
            return new Promise((resolve, reject) => {
                getKhoroojHistory().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_KHOROOJ_HISTORY', data)
                    commit('SET_TABLE_TEXT', false)

                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getLastKhorooj({ commit }) {
            return new Promise((resolve, reject) => {
                getLastKhorooj().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_LAST_KHOROOJ', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}